import { useState } from 'react'

const DISMISSED_KEY = 'petrotrack_trial_banner_dismissed'

export default function TrialBanner({ trialEndsAt, navigate }) {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === '1'
  )

  if (!trialEndsAt || dismissed) return null

  const msLeft   = trialEndsAt - new Date()
  const daysLeft = Math.ceil(msLeft / 86_400_000)

  // Hide banner once trial has expired (the billing page handles that separately)
  if (daysLeft <= 0) return null

  // Only show for the first 7 days of the trial window
  const TRIAL_DAYS = 14
  const daysUsed   = TRIAL_DAYS - daysLeft
  if (daysUsed > 7) return null

  const urgency = daysLeft <= 3 ? 'red' : daysLeft <= 7 ? 'amber' : 'green'
  const colours = {
    green: { bg: 'bg-green-900/40',  border: 'border-green-500/30', text: 'text-green-300', btn: 'bg-green-500 text-black' },
    amber: { bg: 'bg-amber-900/30',  border: 'border-amber-500/30', text: 'text-amber-300', btn: 'bg-amber-400 text-black' },
    red:   { bg: 'bg-red-900/30',    border: 'border-red-500/30',   text: 'text-red-300',   btn: 'bg-red-500 text-white'  },
  }[urgency]

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, '1')
    setDismissed(true)
  }

  return (
    <div className={`${colours.bg} ${colours.border} border rounded-xl px-4 py-3 mb-4 flex items-center justify-between gap-3`}>
      <p className={`text-sm font-medium ${colours.text}`}>
        You're on a free trial —{' '}
        <strong>{daysLeft} day{daysLeft !== 1 ? 's' : ''} remaining</strong>.
      </p>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={() => navigate('/billing')}
          className={`${colours.btn} text-xs font-semibold px-3 py-1.5 rounded-lg transition-opacity hover:opacity-80`}
        >
          Upgrade now
        </button>
        <button
          onClick={dismiss}
          className="text-white/30 hover:text-white/60 text-lg leading-none"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  )
}
